import React from 'react';
import { Check, X } from '@wix/wix-ui-icons-common';
import { classes } from './RichTextInputAreaForm.st.css.js';
import { RichTextInputAreaContext } from '../RichTextInputAreaContext';
import Tooltip from '../../Tooltip';
import Box from '../../Box';
import IconButton from '../../IconButton';
class RichTextInputAreaForm extends React.PureComponent {
    render() {
        const { dataHook, children, onSubmit, onCancel, isDisabled } = this.props;
        return (React.createElement(RichTextInputAreaContext.Consumer, null, ({ texts }) => (React.createElement("form", { "data-hook": dataHook, onSubmit: onSubmit, className: classes.root },
            children,
            React.createElement("div", { className: classes.footer },
                React.createElement(Tooltip, { content: texts.insertionForm.confirmButtonLabel },
                    React.createElement(IconButton, { dataHook: "richtextarea-form-confirm-button", type: "submit", size: "small", onClick: onSubmit, disabled: isDisabled },
                        React.createElement(Check, null))),
                React.createElement(Box, { inline: true, marginRight: 1, marginLeft: 1 },
                    React.createElement(Tooltip, { content: texts.insertionForm.cancelButtonLabel },
                        React.createElement(IconButton, { dataHook: "richtextarea-form-cancel-button", priority: "secondary", size: "small", onClick: onCancel },
                            React.createElement(X, null)))))))));
    }
}
export default RichTextInputAreaForm;
//# sourceMappingURL=RichTextInputAreaForm.js.map